import styled from "styled-components";

export const AddressPopupStyle = styled.div`
    .modal {
        .ant-modal-content {
            padding: 50px 24px;
        }
    }
`